// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"arrow-right-down"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.24748 16.0257H16.0257V8.24748M15.1462 15.1462L8 8","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowRightDownIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-right-down',
    ref,
    icon: element,
  },
));

ArrowRightDownIcon.displayName = 'ArrowRightDownIcon';

export default ArrowRightDownIcon;
